import { StripeCheckoutStep, type TenantRegistrationConfig } from '@/tenants/_shared/registration';

/**
 * UWR registration engine config: embedded Stripe Payment Element checkout
 * (handoff to /donate/checkout), campaign-driven marketing opt-ins, shipping
 * only when a selected item requires it. Theming comes from the
 * [data-tenant='uwr'] CSS scope — no styling config.
 */
export const uwrRegistrationConfig: TenantRegistrationConfig = {
  tenantSlug: 'uwr',
  vehicleType: 'motorcycle',
  CheckoutStep: StripeCheckoutStep,
  marketingOptIns: { source: 'campaign' },
  showNewsletterOptIn: false,
  shippingRule: 'item-flag-only',
  donationPresetsUsd: [25, 50, 100, 250],
  allowSkipCheckout: true,
  waiverNamespace: 'waiver',
  eventDateKey: 'uwrRegister.eventDate',
  campaignClosedBodyKey: 'register.campaignClosedBodyUwr',
  analyticsCheckoutMode: 'embedded',
};
